import { Config } from './types';

export const gamma: Config = {
  CONSENT_MANAGER_SCRIPT_URL:
    'https://db8rtia09p9iz.cloudfront.net/common/static/consent-manager.js',
  HEAP_ID: '2552228339',
};
